import type { AttributeChangeProps } from '../../../types';
import { TextField } from '@flos/react-ui';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { opcInfoAtom } from '../../../../../recoil/atoms/opcInfoAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

const PetChipIdChange = ({ updateCoverableAttribute }: AttributeChangeProps): React.JSX.Element => {
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const getHippoText = useHippoText();
    const opcInfo = useRecoilValue(opcInfoAtom);
    const coverableInfo = useRecoilValue(getCoverableInfoSelector);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    return (
        <>
            <h6>
                {getHippoText('DSS-PET-OPC-EDIT-CHIP-NUMBER-QUESTION', {
                    pet_name:
                        opcInfo.productName === 'topdanmark_dog'
                            ? coverableInfo.petName ?? ''
                            : 'kattens'
                })}
            </h6>
            <TextField
                id="ChipIdChange"
                label="Indtast nummer"
                onBlur={(e) => {
                    updateCoverableAttribute({ chipId: e.target.value });
                    setIsOpcDataFilled(true);
                }}
                disabled={isOpcFetching}
            />
        </>
    );
};

export default PetChipIdChange;
